import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Rooms from './views/Rooms.vue'
import Gallery from './views/Gallery.vue'
import ContactUs from './views/ContactUs.vue'
import Search from './views/search.vue'
import bookingForm from './views/booking-form.vue'
import bookDetails from './views/book-details.vue'

import reciept from './views/reciept.vue'
import customerDashboard from './views/customer-dashboard.vue'
import myReservations from './views/my-reservations.vue'
import myPayments from './views/my-payments.vue'
import profile from './views/profile.vue'
import checkout from './views/checkout.vue'
import Constants from './common/Constants.js'
import axios from 'axios'

import about from './views/About.vue'
import resturant from './views/resturant.vue'
import spar from './views/spar-fitness.vue'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/rooms',
      name: 'rooms',
      component: Rooms
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/book-details',
      name: 'book-details',
      component: bookDetails
    },
    {
      path: '/customer-dashboard',
      name: 'customer-dashboard',
      component: customerDashboard
    },

    {
      path: '/my-reservations',
      name: 'my-reservations',
      component: myReservations,
      meta: { requiresAuth: true },
    },
    {
      path: '/my-payments',
      name: 'my-payments',
      component: myPayments,
      meta: { requiresAuth: true },
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile,
      meta: { requiresAuth: true },
    },

    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/resturant',
      name: 'resturant',
      component: resturant
    },

    {
      path: '/spar-fitness',
      name: 'spar-fitness',
      component: spar
    },
    {
      path: '/booking-form',
      name: 'booking-form',
      component: bookingForm
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: checkout
    },
    {
      path: '/reciept',
      name: 'reciept',
      component: reciept
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import( /* webpackChunkName: "about" */ './views/About.vue')
    // },
    // {
    //   path: '/spar-fitness',
    //   name: 'spar',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import( /* webpackChunkName: "about" */ './views/spar-fitness.vue')
    // },
    // {
    //   path: '/resturant',
    //   name: 'resturant',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import( /* webpackChunkName: "about" */ './views/resturant.vue')
    // },
    {
      path: '/event',
      name: 'event',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/event.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {

  if (to.meta.requiresAuth) {
    axios.post(Constants.API_JWT_VERIFICATION_URL,{
        jwt_token: localStorage.userToken
      }, { 
        headers: { 
          Authorization: "Bearer " +  localStorage.userToken 
        }
      }
    )
    .then(response=>{
      if(response.data.user){
          localStorage.user = JSON.stringify(response.data.user);
          localStorage.userToken = response.data.user.token;
          next();
      }else{
          router.push('/');
      }
    }).catch(function (error) {
      if (error.response) {
            
        if(error.response.status == 400){
          localStorage.clear();
          
          router.push('/');
        }else if(error.response.status == 500){
          // alert("yeeeeeee")

            var message = "Unable to complete request."
            router.go(-1);
        }
        localStorage.clear();
      }
      
    });
  }
  next()
})

export default router;